import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(@Inject(DOCUMENT) private _document: Document) {}

  getPageTitle(): string | null | undefined {
    const titleElement = this._document.querySelector('ion-title');
    return titleElement?.textContent;
  }
}
